<template>
  <v-container fill-height>
    <v-card 
      v-if="isOneTime"
      flat 
      class="rounded-lg py-10 px-10" 
      width="100%"
      style="margin-left: auto; margin-right: auto; max-width: fit-content;"
    >
      <div class="d-flex justify-center mt-3">
        <v-icon x-large color="#D69120">question_answer</v-icon>
      </div>
      <v-card-title class="d-flex justify-center pt-1">
        <span style="font-size: 20px;">บัญชี "{{usernameOneID ? usernameOneID : 'Unknown User'}}"</span>
      </v-card-title>
      <v-card-subtitle class="d-flex justify-center pt-1">
        <span style="font-size: 20px;">ได้ทำแบบสอบถามนี้ไปแล้ว</span>
      </v-card-subtitle>
    </v-card>
  </v-container>
</template>

<script>
// import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      isOneTime: false,
      usernameOneID: '',
    }
  },
  mounted() {
    if (this.$route.query.code !== undefined) {
      let bodyData = {
        grant_type: process.env.VUE_APP_grant_type,
        client_id: process.env.VUE_APP_client_id,
        client_secret: process.env.VUE_APP_client_secret,
        code: this.$route.query.code,
        redirect_uri: process.env.VUE_APP_REDIRECT_ONEID_WEBFORM,
      };
      this.$axios
        .post(process.env.VUE_APP_uriOneService + "oauth/token", bodyData)
        .then((req) => {
          if (req.data) {
            let data = {
              surveySession: "",
              surveyID: this.$cookies.get(
                process.env.VUE_APP_COOKIE + "_LoginWithOneID_surveyID"
              ),
              questionID: "start",
              answer: "",
              socialType: "webform",
              socialID: this.$cookies.get(
                process.env.VUE_APP_COOKIE + "_LoginWithOneID_surveyID"
              ),
              userID: req.data.account_id,
              username: req.data.username,
            };
            this.$store
              .dispatch("StartForm", data)
              .then((response) => {
                this.$store.commit("setFirstquestion", response.questionInfo);
                this.$cookies.set(
                  process.env.VUE_APP_COOKIE + "_surveyInfo",
                  response.surveyInfo
                );
                this.$cookies.set(
                  process.env.VUE_APP_COOKIE +
                    "_" +
                    response.surveySession +
                    "_questionStep",
                  {
                    qlist: [response.questionInfo.questionID],
                  }
                );
                this.$router.push({
                  name: "webform",
                  query: {
                    surveyID: this.$cookies.get(
                      process.env.VUE_APP_COOKIE + "_LoginWithOneID_surveyID"
                    ),
                    surveySession: response.surveySession,
                    username: req.data.username,
                    userID: req.data.account_id,
                    questionID: response.questionInfo.questionID,
                  },
                });
              })
              .catch((err) => {
                // console.log('err validate',err);
                if (err.data.message === "surveyInfo not in Schedule Time") {
                  Swal.fire({
                    icon: "warning",
                    text: "แบบสอบถามนี้ถูกเปลี่ยนให้สามารถทำได้ตามช่วงเวลาที่กำหนดเท่านั้น",
                    title: "",
                  }).then(() => {
                    location.reload();
                  });
                } else if (err.data.message === "surveyInfo status inactive") {
                  Swal.fire({
                    icon: "warning",
                    text: "แบบสอบถามนี้ปิดรับคำตอบแล้ว",
                    title: "",
                  }).then(() => {
                    location.reload();
                  });
                } else if (
                  err.data.message === "Dont have package or Package Expried"
                ) {
                  Swal.fire({
                    html: `แบบสอบถามนี้ไม่สามารถใช้งานได้ (Dont have package or Package Expried)<br>กรุณาติดต่อเจ้าของแบบสอบถาม`,
                    icon: "warning",
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    confirmButtonColor: "#0093cc",
                    confirmButtonText: "รับทราบ",
                  });
                } else {
                  if (err.data.message ===
                    "surveySession is Duplicate can use survey in one time") {
                    this.isOneTime = true
                    this.usernameOneID = req.data.username
                  } else {
                    this.isOneTime = false
                    let text = "ไม่สามารถเริ่มทำแบบสอบถามได้";
                    if (
                      !this.$cookies.get(
                        process.env.VUE_APP_COOKIE + "_LoginWithOneID_surveyID"
                      )
                    ) {
                      text = text + " (ไม่พบ surveyID)";
                    } else if (
                      err.data.message === "surveyInfo status inactive"
                    ) {
                      text = "แบบสอบถามนี้ปิดรับคำตอบแล้ว";
                    }
                    Swal.fire({
                      icon: "warning",
                      text: text,
                      title: "",
                    }).then(() => {
                      this.$store.state.loading = false;
                      this.$router.push({
                        name: "startform",
                        query: {
                          surveyID: this.$cookies.get(
                            process.env.VUE_APP_COOKIE +
                              "_LoginWithOneID_surveyID"
                          ),
                        },
                      });
                    });
                  }
                }
              });
          }
        })
        .catch((error) => {
          console.log(error.response.data);
          Swal.fire({
            icon: "warning",
            text: "ไม่สามารถเข้าสู่ระบบด้วย OneID ได้",
            title: "",
          }).then(() => {
            this.$store.state.loading = false;
            this.$router.push({
              name: "startform",
              query: {
                surveyID: this.$cookies.get(
                  process.env.VUE_APP_COOKIE + "_LoginWithOneID_surveyID"
                ),
              },
            });
          });
        });
    } else {
      if (this.$route.query.error === "access_denied") {
        Swal.fire({
          icon: "warning",
          text: "คุณปฏิเสธการเข้าสู่ระบบด้วย OneID",
          title: "",
        }).then(() => {
          this.$router.push({
            name: "startform",
            query: {
              surveyID: this.$cookies.get(
                process.env.VUE_APP_COOKIE + "_LoginWithOneID_surveyID"
              ),
            },
          });
        });
      }
    }
  },
};
</script>
